module.exports = __webpack_public_path__ + "static/img/6.f625906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/6.png
// module id = bY3B
// module chunks = 19